import React from 'react';
import { Route, Switch } from 'react-router';
import Dashboard from 'routes/User/Dashboard';
import { withRouter } from 'react-router-dom';
import Profile from 'routes/User/Profile';
import TermsAndConditions from 'routes/User/TermsAndConditions';
import PrivacyPolicy from 'routes/User/PrivacyPolicy';
import ContactUs from 'routes/User/ContactUs';
import Reminders from 'routes/User/Reminders';

const Manager = withRouter(({ match }) => (
	<Switch>
		<Route path={`${match.url}`} exact component={Dashboard} />
		<Route path={`${match.url}/profile`} component={Profile} />
		<Route path={`${match.url}/terms`} component={TermsAndConditions} />
		<Route path={`${match.url}/privacy`} component={PrivacyPolicy} />
		<Route path={`${match.url}/contact`} component={ContactUs} />
		<Route path={`${match.url}/reminders`} component={Reminders} />
	</Switch>
));

export default Manager;



// WEBPACK FOOTER //
// ./src/routes/User/index.js